import { render } from "./BFaceRestoreButton.vue?vue&type=template&id=35d1d5c7"
import script from "./BFaceRestoreButton.vue?vue&type=script&lang=js"
export * from "./BFaceRestoreButton.vue?vue&type=script&lang=js"
script.render = render

export default script